import { useQuery } from "@tanstack/react-query";
import type { MonthGuidance, ResourceGuidance } from "@/api/guidance";
import { guidanceKeys } from "@/lib/query";

export type { MonthGuidance };

async function fetchGuidance(): Promise<ResourceGuidance[]> {
  const res = await fetch("/api/dashboard/guidance");
  if (!res.ok) throw new Error("guidance unavailable");
  return res.json();
}

export function useGuidance(): {
  byResource: Map<string, MonthGuidance[]>;
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useQuery<ResourceGuidance[]>({
    queryKey: guidanceKeys.list(),
    queryFn: fetchGuidance,
    staleTime: 5 * 60 * 1000,
  });
  const byResource = new Map<string, MonthGuidance[]>(
    (data ?? []).map((r) => [r.resourceId, r.months]),
  );
  return { byResource, isLoading, isError };
}
